module.exports = __webpack_public_path__ + "img/kv.16b7c38f.png";